import { Component } from '@angular/core';

@Component({
  selector: 'app-test',
  template: `
    <div class="bg-white text-gray-900 min-h-screen font-sans">
      <!-- Navbar -->
      <nav class="sticky top-0 z-50 bg-white border-b border-gray-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between h-16">
            <div class="flex items-center">
              <div class="flex-shrink-0 flex items-center">
                <span class="text-2xl font-semibold">Notion</span>
              </div>
            </div>
            <div class="hidden md:flex items-center space-x-4">
              <button class="px-4 py-2 rounded-md text-gray-700 hover:bg-gray-100">Pricing</button>
              <button class="px-4 py-2 rounded-md text-gray-700 hover:bg-gray-100">Log in</button>
              <button class="px-4 py-2 rounded-md bg-black text-white hover:bg-gray-800">Get Notion free</button>
            </div>
            <div class="flex items-center md:hidden">
              <button class="p-2 rounded-md text-gray-700 hover:bg-gray-100">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <!-- Hero Section -->
      <section class="py-12 md:py-20">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 class="text-4xl md:text-6xl font-bold tracking-tight">
            The happier workspace
          </h1>
          <p class="mt-6 text-xl md:text-2xl max-w-2xl mx-auto">
            Write. Plan. Collaborate. With a little help from AI.
          </p>
          <div class="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <button class="px-8 py-4 rounded-md bg-black text-white hover:bg-gray-800 text-lg font-medium">
              Get Notion free
            </button>
            <button class="px-8 py-4 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 text-lg font-medium">
              Request a demo
            </button>
          </div>

          <div class="mt-12 text-gray-500 text-sm">
            <p>Trusted by teams at</p>
            <div class="mt-4 flex flex-wrap justify-center gap-8">
              <span class="text-xl font-semibold">Toyota</span>
              <span class="text-xl font-semibold">Vercel</span>
              <span class="text-xl font-semibold">Figma</span>
              <span class="text-xl font-semibold">Ramp</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Features Tabs -->
      <section class="py-12 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="grid grid-cols-3 md:grid-cols-6 gap-4 text-center">
            <div class="bg-white shadow-sm rounded-lg p-4 hover:shadow-md cursor-pointer">
              <div class="text-3xl mb-2">📝</div>
              <div>Wikis</div>
            </div>
            <div class="bg-white shadow-sm rounded-lg p-4 hover:shadow-md cursor-pointer">
              <div class="text-3xl mb-2">📄</div>
              <div>Docs</div>
            </div>
            <div class="bg-white shadow-sm rounded-lg p-4 hover:shadow-md cursor-pointer">
              <div class="text-3xl mb-2">📊</div>
              <div>Projects</div>
            </div>
            <div class="bg-white shadow-sm rounded-lg p-4 hover:shadow-md cursor-pointer">
              <div class="text-3xl mb-2">🤖</div>
              <div>AI</div>
            </div>
            <div class="bg-white shadow-sm rounded-lg p-4 hover:shadow-md cursor-pointer">
              <div class="text-3xl mb-2">📅</div>
              <div>Calendar</div>
            </div>
            <div class="bg-white shadow-sm rounded-lg p-4 hover:shadow-md cursor-pointer">
              <div class="text-3xl mb-2">🌐</div>
              <div>Sites</div>
            </div>
          </div>
        </div>
      </section>

      <!-- Docs Feature -->
      <section class="py-16">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex flex-col md:flex-row items-center gap-8">
            <div class="md:w-1/2">
              <h2 class="text-3xl font-bold">Build perfect docs, together.</h2>
              <p class="mt-4 text-lg text-gray-600">
                Capture your ideas, get feedback from teammates, and ask AI to add the finishing touches.
              </p>
              <a href="#" class="mt-6 inline-flex items-center text-blue-600 hover:text-blue-800">
                Explore docs & notes →
              </a>

              <div class="mt-8 space-y-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">Building blocks</h3>
                    <p class="text-gray-600">100+ content types to communicate any idea.</p>
                  </div>
                </div>

                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">Collaborative tools</h3>
                    <p class="text-gray-600">Built for teams to share, suggest, and comment.</p>
                  </div>
                </div>

                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">AI-assisted</h3>
                    <p class="text-gray-600">Edit, draft, translate. Ask and AI will help.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="md:w-1/2 mt-8 md:mt-0">
              <div class="rounded-xl shadow-xl overflow-hidden">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=2048/front-static/shared/illustrations/blocks/text.png"
                     alt="Notion Document" class="w-full h-auto" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Projects Feature -->
      <section class="py-16 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex flex-col md:flex-row-reverse items-center gap-8">
            <div class="md:w-1/2">
              <h2 class="text-3xl font-bold">Your workflow. Your way.</h2>
              <p class="mt-4 text-lg text-gray-600">
                All your projects, goals, calendars, roadmaps, and more—in one tool—personalized to how you and your team work.
              </p>
              <a href="#" class="mt-6 inline-flex items-center text-blue-600 hover:text-blue-800">
                Explore projects →
              </a>

              <div class="mt-8 space-y-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">Tasks and to-dos</h3>
                    <p class="text-gray-600">Tackle any project, big or small.</p>
                  </div>
                </div>

                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">Custom views</h3>
                    <p class="text-gray-600">Visualize work in any format, from calendars to boards.</p>
                  </div>
                </div>

                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">Automations</h3>
                    <p class="text-gray-600">Put tedious tasks on autopilot.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="md:w-1/2 mt-8 md:mt-0">
              <div class="rounded-xl shadow-xl overflow-hidden">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=2048/front-static/shared/illustrations/teamwork-project.png"
                     alt="Notion Projects" class="w-full h-auto" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Wikis Feature -->
      <section class="py-16">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex flex-col md:flex-row items-center gap-8">
            <div class="md:w-1/2">
              <h2 class="text-3xl font-bold">Find everything. Instantly.</h2>
              <p class="mt-4 text-lg text-gray-600">
                No more endless searching. Our built-in AI finds what you're looking for, whether its stored in Notion or one of your other apps.
              </p>
              <a href="#" class="mt-6 inline-flex items-center text-blue-600 hover:text-blue-800">
                Explore knowledge management →
              </a>

              <div class="mt-8 space-y-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">Teamspaces</h3>
                    <p class="text-gray-600">Dedicated spaces for every team & project.</p>
                  </div>
                </div>

                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">Integrations</h3>
                    <p class="text-gray-600">Connected to all your other tools.</p>
                  </div>
                </div>

                <div class="flex items-start">
                  <div class="flex-shrink-0 bg-blue-100 rounded-md p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-lg font-medium">Just ask AI</h3>
                    <p class="text-gray-600">Trusted answers across your apps.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="md:w-1/2 mt-8 md:mt-0">
              <div class="rounded-xl shadow-xl overflow-hidden">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=2048/front-static/shared/illustrations/teamwork-wiki.png"
                     alt="Notion Wiki" class="w-full h-auto" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- AI Feature -->
      <section class="py-16 bg-gradient-to-r from-purple-50 to-blue-50">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <h2 class="text-4xl font-bold">Your AI everything app.</h2>
            <p class="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              Get a brain boost.
            </p>
            <p class="mt-2 text-xl text-gray-600 max-w-3xl mx-auto">
              Built right into your workspace, Notion AI is ready to brainstorm, summarize, help you write, and find what you're looking for.
            </p>
            <a href="#" class="mt-6 inline-flex items-center text-blue-600 hover:text-blue-800">
              Try Notion AI →
            </a>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div class="bg-white p-6 rounded-xl shadow-sm">
              <div class="text-3xl mb-4">🔍</div>
              <h3 class="text-lg font-medium mb-2">Instant answers</h3>
              <p class="text-gray-600">Ask any question about a team's docs and projects.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm">
              <div class="text-3xl mb-4">✍️</div>
              <h3 class="text-lg font-medium mb-2">Personalized editor</h3>
              <p class="text-gray-600">Generate content that's always relevant.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm">
              <div class="text-3xl mb-4">🔌</div>
              <h3 class="text-lg font-medium mb-2">AI connectors <span class="text-xs bg-blue-100 text-blue-800 px-1 py-0.5 rounded">beta</span></h3>
              <p class="text-gray-600">Access info from Slack, Google Drive and more, right inside Notion.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Templates Section -->
      <section class="py-16">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold">Start with a template. Build anything.</h2>
            <a href="#" class="mt-4 inline-flex items-center text-blue-600 hover:text-blue-800">
              Browse all templates →
            </a>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div class="group cursor-pointer">
              <div class="rounded-xl overflow-hidden shadow-sm group-hover:shadow-md">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=640/front-static/pages/home/company-wiki-template.png"
                     alt="Company Wiki" class="w-full h-auto" />
              </div>
              <h3 class="mt-4 text-lg font-medium group-hover:text-blue-600">Company Wiki →</h3>
            </div>

            <div class="group cursor-pointer">
              <div class="rounded-xl overflow-hidden shadow-sm group-hover:shadow-md">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=640/front-static/pages/home/roadmap-template.png"
                     alt="Project Roadmap" class="w-full h-auto" />
              </div>
              <h3 class="mt-4 text-lg font-medium group-hover:text-blue-600">Project Roadmap →</h3>
            </div>

            <div class="group cursor-pointer">
              <div class="rounded-xl overflow-hidden shadow-sm group-hover:shadow-md">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=640/front-static/pages/home/okrs-template.png"
                     alt="OKRs" class="w-full h-auto" />
              </div>
              <h3 class="mt-4 text-lg font-medium group-hover:text-blue-600">OKRs →</h3>
            </div>

            <div class="group cursor-pointer">
              <div class="rounded-xl overflow-hidden shadow-sm group-hover:shadow-md">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=640/front-static/pages/home/meeting-notes-template.png"
                     alt="Meeting Notes" class="w-full h-auto" />
              </div>
              <h3 class="mt-4 text-lg font-medium group-hover:text-blue-600">Meeting Notes →</h3>
            </div>

            <div class="group cursor-pointer">
              <div class="rounded-xl overflow-hidden shadow-sm group-hover:shadow-md">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=640/front-static/pages/home/vacation-template.png"
                     alt="Vacation Planner" class="w-full h-auto" />
              </div>
              <h3 class="mt-4 text-lg font-medium group-hover:text-blue-600">Vacation Planner →</h3>
            </div>

            <div class="group cursor-pointer">
              <div class="rounded-xl overflow-hidden shadow-sm group-hover:shadow-md">
                <img src="https://www.notion.so/cdn-cgi/image/format=webp,width=640/front-static/pages/home/editorial-template.png"
                     alt="Editorial Calendar" class="w-full h-auto" />
              </div>
              <h3 class="mt-4 text-lg font-medium group-hover:text-blue-600">Editorial Calendar →</h3>
            </div>
          </div>
        </div>
      </section>

      <!-- Features Grid -->
      <section class="py-16 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 class="text-3xl font-bold text-center mb-12">Everything you need to do your best work.</h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div class="bg-white p-6 rounded-xl shadow-sm hover:shadow-md">
              <div class="text-3xl mb-4">📝</div>
              <h3 class="text-lg font-medium mb-2">Docs →</h3>
              <p class="text-gray-600">Build any page, communicate any idea.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm hover:shadow-md">
              <div class="text-3xl mb-4">📚</div>
              <h3 class="text-lg font-medium mb-2">Wiki →</h3>
              <p class="text-gray-600">One home base for all your knowledge.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm hover:shadow-md">
              <div class="text-3xl mb-4">📊</div>
              <h3 class="text-lg font-medium mb-2">Projects →</h3>
              <p class="text-gray-600">Manage any project from beginning to end.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm hover:shadow-md">
              <div class="text-3xl mb-4">🤖</div>
              <h3 class="text-lg font-medium mb-2">Notion AI →</h3>
              <p class="text-gray-600">Finds what you need. Does what you need.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm hover:shadow-md">
              <div class="text-3xl mb-4">📅</div>
              <h3 class="text-lg font-medium mb-2">Calendar →</h3>
              <p class="text-gray-600">See all your commitments in one place.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm hover:shadow-md">
              <div class="text-3xl mb-4">🎯</div>
              <h3 class="text-lg font-medium mb-2">Goals →</h3>
              <p class="text-gray-600">Track progress toward what's most important.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm hover:shadow-md">
              <div class="text-3xl mb-4">🌐</div>
              <h3 class="text-lg font-medium mb-2">Sites →</h3>
              <p class="text-gray-600">Make any page a website in minutes.</p>
            </div>

            <div class="bg-white p-6 rounded-xl shadow-sm hover:shadow-md">
              <div class="text-3xl mb-4">📋</div>
              <h3 class="text-lg font-medium mb-2">Templates →</h3>
              <p class="text-gray-600">Get started with one of 30,000+ templates.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA Section -->
      <section class="py-16">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center">
            <h2 class="text-3xl font-bold mb-6">Get started.</h2>

            <div class="flex flex-col sm:flex-row justify-center gap-6">
              <div class="bg-white border border-gray-200 rounded-xl p-6 text-center sm:w-80">
                <h3 class="text-xl font-medium mb-4">Notion</h3>
                <div class="flex flex-col gap-2">
                  <button class="px-4 py-2 w-full bg-black text-white rounded-md hover:bg-gray-800">
                    Try it free
                  </button>
                  <button class="px-4 py-2 w-full border border-gray-300 rounded-md hover:bg-gray-50">
                    Download now
                  </button>
                </div>
                <div class="mt-4">
                  <img src="https://www.notion.so/cdn-cgi/image/format=auto,width=256,quality=100/front-static/shared/illustrations/devices/notion-app.png"
                       alt="Notion app" class="h-24 mx-auto" />
                </div>
              </div>

              <div class="bg-white border border-gray-200 rounded-xl p-6 text-center sm:w-80">
                <h3 class="text-xl font-medium mb-4">Notion Calendar</h3>
                <div class="flex flex-col gap-2">
                  <button class="px-4 py-2 w-full bg-black text-white rounded-md hover:bg-gray-800">
                    Try it free
                  </button>
                  <button class="px-4 py-2 w-full border border-gray-300 rounded-md hover:bg-gray-50">
                    Download now
                  </button>
                </div>
                <div class="mt-4">
                  <img src="https://www.notion.so/cdn-cgi/image/format=auto,width=256,quality=100/front-static/shared/illustrations/devices/notion-calendar.png"
                       alt="Notion Calendar" class="h-24 mx-auto" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Footer -->
      <footer class="bg-gray-100 py-12">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h3 class="font-medium mb-4">Company</h3>
              <ul class="space-y-2">
                <li><a href="#" class="text-gray-600 hover:text-gray-900">About us</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Careers</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Security</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Status</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Terms & privacy</a></li>
              </ul>
            </div>

            <div>
              <h3 class="font-medium mb-4">Download</h3>
              <ul class="space-y-2">
                <li><a href="#" class="text-gray-600 hover:text-gray-900">iOS & Android</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Mac & Windows</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Calendar</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Web Clipper</a></li>
              </ul>
            </div>

            <div>
              <h3 class="font-medium mb-4">Resources</h3>
              <ul class="space-y-2">
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Help center</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Pricing</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Blog</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Community</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Integrations</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Templates</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Affiliates</a></li>
              </ul>
            </div>

            <div>
              <h3 class="font-medium mb-4">Notion for</h3>
              <ul class="space-y-2">
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Enterprise</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Small business</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Personal</a></li>
                <li><a href="#" class="text-gray-600 hover:text-gray-900">Explore more →</a></li>
              </ul>
            </div>
          </div>

          <div class="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
            <div class="mb-4 md:mb-0">
              <p class="text-gray-500 text-sm">© 2025 Notion Labs, Inc.</p>
            </div>
            <div class="flex space-x-6">
              <a href="#" class="text-gray-500 hover:text-gray-900">
                <span class="sr-only">Twitter</span>
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
              <a href="#" class="text-gray-500 hover:text-gray-900">
                <span class="sr-only">LinkedIn</span>
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill-rule="evenodd" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  `,
  standalone: false
})
export class TestComponent {}
